"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkError = exports.sanitizeAPIError = exports.isAbortError = exports.emptyRequest = exports.postForEmpty = exports.getForEmpty = exports.getJson = exports.putForJson = exports.postForJson = exports.postAuthForEmpty = exports.getAuthBlob = exports.postAuthFile = exports.deleteAuthJson = exports.deleteAuth = exports.getAuthJson = exports.putAuthJson = exports.postAuthJson = exports.simpleGetFile = exports.simplePostFile = exports.simpleDelete = exports.simpleGet = exports.simplePut = exports.simplePost = void 0;
var environment_1 = require("./environment");
function simplePost(args) {
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, postAuthJson(args)];
                case 1:
                    res = _a.sent();
                    return [2, res.json];
            }
        });
    });
}
exports.simplePost = simplePost;
function simplePut(args) {
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, putAuthJson(args)];
                case 1:
                    res = _a.sent();
                    return [2, res.json];
            }
        });
    });
}
exports.simplePut = simplePut;
function simpleGet(args) {
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getAuthJson(args)];
                case 1:
                    res = _a.sent();
                    return [2, res.json];
            }
        });
    });
}
exports.simpleGet = simpleGet;
function simpleDelete(args) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, deleteAuth(args)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    });
}
exports.simpleDelete = simpleDelete;
function simplePostFile(args) {
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, postAuthFile(args)];
                case 1:
                    res = _a.sent();
                    return [2, res.json];
            }
        });
    });
}
exports.simplePostFile = simplePostFile;
function simpleGetFile(args) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, blob, headers, fileName;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, getAuthBlob(args)];
                case 1:
                    _a = _b.sent(), blob = _a.blob, headers = _a.headers;
                    fileName = getFileName(headers);
                    return [2, {
                            blob: blob,
                            fileName: fileName,
                        }];
            }
        });
    });
}
exports.simpleGetFile = simpleGetFile;
function stringifyBody(body) {
    if (body === undefined || body === null) {
        return undefined;
    }
    else {
        return JSON.stringify(body);
    }
}
function postAuthJson(args) {
    return jsonRequest({
        body: stringifyBody(args.body),
        endpoint: environment_1.Environment.endpoint(args.path),
        headers: {
            Authorization: "Bearer " + environment_1.Environment.authToken,
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        method: "POST",
        signal: args.signal,
    });
}
exports.postAuthJson = postAuthJson;
function putAuthJson(args) {
    return jsonRequest({
        body: stringifyBody(args.body),
        endpoint: environment_1.Environment.endpoint(args.path),
        headers: {
            Authorization: "Bearer " + environment_1.Environment.authToken,
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        method: "PUT",
        signal: args.signal,
    });
}
exports.putAuthJson = putAuthJson;
function getAuthJson(args) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, jsonRequest({
                        endpoint: environment_1.Environment.endpoint(args.path),
                        headers: {
                            Authorization: "Bearer " + environment_1.Environment.authToken,
                            Accept: "application/json",
                        },
                        method: "GET",
                        signal: args.signal,
                    })];
                case 1: return [2, _a.sent()];
            }
        });
    });
}
exports.getAuthJson = getAuthJson;
function deleteAuth(args) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, emptyRequest({
                        endpoint: environment_1.Environment.endpoint(args.path),
                        headers: {
                            Authorization: "Bearer " + environment_1.Environment.authToken,
                        },
                        method: "DELETE",
                        signal: args.signal,
                    })];
                case 1: return [2, _a.sent()];
            }
        });
    });
}
exports.deleteAuth = deleteAuth;
function deleteAuthJson(args) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, jsonRequest({
                        endpoint: environment_1.Environment.endpoint(args.path),
                        headers: {
                            Authorization: "Bearer " + environment_1.Environment.authToken,
                            Accept: "application/json",
                        },
                        method: "DELETE",
                        signal: args.signal,
                    })];
                case 1: return [2, _a.sent()];
            }
        });
    });
}
exports.deleteAuthJson = deleteAuthJson;
function postAuthFile(args) {
    var fd = new FormData();
    fd.append("file", args.file);
    return jsonRequest({
        body: fd,
        endpoint: environment_1.Environment.endpoint(args.path),
        headers: {
            Authorization: "Bearer " + environment_1.Environment.authToken,
            Accept: "application/json",
        },
        method: "POST",
        signal: args.signal,
    });
}
exports.postAuthFile = postAuthFile;
function getAuthBlob(args) {
    return blobRequest({
        endpoint: environment_1.Environment.endpoint(args.path),
        headers: {
            Authorization: "Bearer " + environment_1.Environment.authToken,
            Accept: args.mediaType,
        },
        method: "GET",
        signal: args.signal,
    });
}
exports.getAuthBlob = getAuthBlob;
function postAuthForEmpty(args) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, options, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    endpoint = environment_1.Environment.endpoint(args.path);
                    options = {
                        method: "POST",
                        headers: {
                            Authorization: "Bearer " + environment_1.Environment.authToken,
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                        body: stringifyBody(args.body),
                        mode: "cors",
                    };
                    return [4, fetch(endpoint, options)];
                case 1:
                    response = _b.sent();
                    if (!!response.ok) return [3, 3];
                    _a = NetworkError.bind;
                    return [4, response.json()];
                case 2: throw new (_a.apply(NetworkError, [void 0, _b.sent()]))();
                case 3: return [2, response];
            }
        });
    });
}
exports.postAuthForEmpty = postAuthForEmpty;
function postForJson(args) {
    return jsonRequest({
        body: stringifyBody(args.body),
        endpoint: environment_1.Environment.endpoint(args.path),
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        method: "POST",
        signal: args.signal,
    });
}
exports.postForJson = postForJson;
function putForJson(args) {
    return jsonRequest({
        body: stringifyBody(args.body),
        endpoint: environment_1.Environment.endpoint(args.path),
        headers: {
            Authorization: "Bearer " + environment_1.Environment.authToken,
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        method: "PUT",
        signal: args.signal,
    });
}
exports.putForJson = putForJson;
function getJson(args) {
    return jsonRequest({
        endpoint: environment_1.Environment.endpoint(args.path),
        headers: {
            Accept: "application/json",
        },
        method: "GET",
        signal: args.signal,
    });
}
exports.getJson = getJson;
function getForEmpty(args) {
    return __awaiter(this, void 0, void 0, function () {
        var response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4, fetch(environment_1.Environment.endpoint(args.path), {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        },
                        mode: "cors",
                    })];
                case 1:
                    response = _b.sent();
                    if (!!response.ok) return [3, 3];
                    _a = NetworkError.bind;
                    return [4, response.json()];
                case 2: throw new (_a.apply(NetworkError, [void 0, _b.sent()]))();
                case 3: return [2, response];
            }
        });
    });
}
exports.getForEmpty = getForEmpty;
function postForEmpty(args) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, options, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    endpoint = environment_1.Environment.endpoint(args.path);
                    options = {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                        body: stringifyBody(args.body),
                        mode: "cors",
                    };
                    return [4, fetch(endpoint, options)];
                case 1:
                    response = _b.sent();
                    if (!!response.ok) return [3, 3];
                    _a = NetworkError.bind;
                    return [4, response.json()];
                case 2: throw new (_a.apply(NetworkError, [void 0, _b.sent()]))();
                case 3: return [2, response];
            }
        });
    });
}
exports.postForEmpty = postForEmpty;
function jsonRequest(args) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, method, headers, body, signal, options, response, json_1, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = args.endpoint, method = args.method, headers = args.headers, body = args.body, signal = args.signal;
                    options = {
                        method: method,
                        headers: headers,
                        body: body,
                        mode: "cors",
                        signal: signal,
                    };
                    return [4, fetch(endpoint, options)];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3, 3];
                    return [4, response.json()];
                case 2:
                    json_1 = _a.sent();
                    if (response.url.includes("/authenticate")) {
                        throw json_1;
                    }
                    else {
                        throw new NetworkError(json_1);
                    }
                    _a.label = 3;
                case 3: return [4, response.json()];
                case 4:
                    json = _a.sent();
                    return [2, {
                            json: json,
                            status: response.status,
                            ok: response.ok,
                        }];
            }
        });
    });
}
function emptyRequest(args) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, method, headers, signal, options, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    endpoint = args.endpoint, method = args.method, headers = args.headers, signal = args.signal;
                    options = {
                        method: method,
                        headers: headers,
                        mode: "cors",
                        signal: signal,
                    };
                    return [4, fetch(endpoint, options)];
                case 1:
                    response = _b.sent();
                    if (!!response.ok) return [3, 3];
                    _a = NetworkError.bind;
                    return [4, response.json()];
                case 2: throw new (_a.apply(NetworkError, [void 0, _b.sent()]))();
                case 3: return [2, response];
            }
        });
    });
}
exports.emptyRequest = emptyRequest;
function getFileName(responseHeaders) {
    var contentDisposition = responseHeaders.get("content-disposition");
    if (contentDisposition) {
        var fileName = /filename="([^"]+)"/.exec(contentDisposition);
        if (fileName) {
            return fileName[1];
        }
    }
    throw new Error("Invalid file response - missing content disposition");
}
function blobRequest(args) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, headers, signal, options, response, _a, blob;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    endpoint = args.endpoint, headers = args.headers, signal = args.signal;
                    options = {
                        method: "GET",
                        headers: headers,
                        mode: "cors",
                        signal: signal,
                    };
                    return [4, fetch(endpoint, options)];
                case 1:
                    response = _b.sent();
                    if (!!response.ok) return [3, 3];
                    _a = NetworkError.bind;
                    return [4, response.json()];
                case 2: throw new (_a.apply(NetworkError, [void 0, _b.sent()]))();
                case 3: return [4, response.blob()];
                case 4:
                    blob = _b.sent();
                    return [2, {
                            blob: blob,
                            headers: response.headers,
                            status: response.status,
                            ok: response.ok,
                        }];
            }
        });
    });
}
function isAbortError(error) {
    var _a;
    return ((_a = error) === null || _a === void 0 ? void 0 : _a.name) === "AbortError";
}
exports.isAbortError = isAbortError;
var sanitizeAPIError = function (error) {
    var _a, _b;
    return {
        env_str: error.env,
        mode_str: error.mode,
        requestBody_str: error.body,
        requestHeaders: {
            Accept_str: (_a = error.headers) === null || _a === void 0 ? void 0 : _a.Accept,
            "Content-Type_str": (_b = error.headers) === null || _b === void 0 ? void 0 : _b["Content-Type"],
        },
        requestMethod_str: error.method,
        responseState_str: error.state,
    };
};
exports.sanitizeAPIError = sanitizeAPIError;
var NetworkError = (function (_super) {
    __extends(NetworkError, _super);
    function NetworkError(params) {
        var _this = _super.call(this, JSON.stringify(params)) || this;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, NetworkError);
        }
        _this.name = "NetworkError";
        _this.detail = params.detail;
        _this.status = params.status;
        _this.title = params.title;
        _this.type = params.type;
        _this.path = params.path;
        _this.message = params.message;
        return _this;
    }
    return NetworkError;
}(Error));
exports.NetworkError = NetworkError;
//# sourceMappingURL=network.js.map